import React, { useEffect, useState } from "react";
import PopupModal from "../../Components/ModalComponent/PopupModal";
import InputComponent from "../../Components/InputComponent/InputComponent";
import AlertBox from "../../Components/AlertBox/AlertBox";
import { ManageApis } from "../../AppServices/ManageApi";
import { Message, Popconfirm, } from "@arco-design/web-react";
import DataTable from "../../Components/DataTable/DataTable";
import { convertUtcToBrowserTimeZone, dataTableInitialLoader } from "../../Functions/Utils";
import { Button } from "react-bootstrap";
import Loader from "../../Components/LoaderComponent/Loader";
import moment from "moment/moment";
import { async } from "q";
import axios from "axios";
// import ErrorPage from "../ErrorPage/ErrorPage";

const dev = false;

function DeploymentServer() {
    const initialAlertValue = { message: '', show: false, enableSuccessIcon: false, enableFailIcon: false }
    const [alertData, setAlertData] = useState(initialAlertValue);
    const initialVisibleValue = { show: false, type: "" }
    const [rowData, setRowData] = useState({});
    const [visible, setvisible] = useState(initialVisibleValue);
    const [TableLoader, setTableLoader] = useState(false);
    const [currentServiceId, setCurrentServiceId] = useState('')


    //up
    const [loader, setloader] = useState(false);
    const [serviceKeyTableData, setServiceKeyTableData] = useState([])
    const [data, setData] = useState([])
    const [serviceNameList, setServiceNameList] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [form, setForm] = useState({
        serviceapiaddress: '',
        path: '',
        key: ''
    })
    const columns = [

        {
            title: "Service",
            dataIndex: 'servicename',
            valueType: 'text',
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },

        },

        {
            title: "Server",
            dataIndex: 'serviceapiaddress',
            valueType: 'text',
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },

        },
        {
            title: "Path",
            dataIndex: 'path',
            valueType: 'text',
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },

        },

        {
            title: "Key",
            dataIndex: 'key',
            valueType: 'text',
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },
            render: (text, record, _, action) => [

                <i
                    class="far fa-eye cursor-pointer px_hover_1 font_18 text_master"
                    onClick={() => { setAlertData((pre) => ({ ...pre, show: true, message: record.key })); setvisible(initialVisibleValue) }}>

                </i>
            ],

        },
        {
            title: "Updated date",
            dataIndex: 'updateddate',
            width: 150,
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },
            render: (v, record) => {
                return (<div>{convertUtcToBrowserTimeZone(record?.updateddate)}</div>)
            }


        },
        {
            title: "Refresh Server",
            // valueType: "option",
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },
            render: (text, record, _, action) => [


                <Popconfirm
                    title="Sure to Refresh?"
                    okText={"OK"}
                    cancelText={"Cancel"}
                    onOk={() => handleRefresh(record.id)}
                >
                    <button className="btn px_btn btn-master py-1 rounded fw_500 font_12 w-100">Refresh</button>

                </Popconfirm>,
            ],
        },
        {
            title: "Actions",
            valueType: "option",
            headerCellStyle: {
                backgroundColor: "var(--mastercolor2)",
                color: "#fff",
            },
            render: (text, record, _, action) => [

                <div className="d-flex">
                    <a key="editable" >
                        <div className="d-flex gap-2">
                            <button className="me-2 btn  px_btn btn-master-line py-1 rounded fw_500 px-2 font_12 w-100" onClick={() => handleAdd('edit', record)}>
                                Edit
                            </button>
                        </div>
                    </a>

                    <Popconfirm
                        title="Sure to delete?"
                        okText={"OK"}
                        cancelText={"Cancel"}
                        onOk={() => handleDelete(record.id)}
                    >
                        <button className="btn px_btn btn-master py-1 rounded fw_500 px-2 font_12 w-100">Delete</button>

                    </Popconfirm>
                </div>
            ],
        },
    ]

    const handleModalClose = () => {
        setvisible(initialVisibleValue);
        // setRowData({})
    }


    useEffect(() => {
        getAddDataServerDeployment()
        getServiceListDetails()
    }, [])

    useEffect(() => {
        //console.log('service key table -->', serviceKeyTableData)
    }, [serviceKeyTableData])

    const getAddDataServerDeployment = async () => {
        try {
            setloader(true)
            if (dev == true) {
                let response = await axios.get('http://localhost:3001/api/ServerManagement/GetAddDataServerDeployment')
                //console.log("response from axios", response)
                setServiceKeyTableData(response.data)
                setData(response.data)
                setloader(false)
            }
            else {
                let response = await ManageApis("get", global.getAddDataServerDeployment)
                //console.log(response)
                if (response.message === "Success") {
                    setloader(false)

                    setServiceKeyTableData(response.response_data)
                    setData(response.response_data)
                    //console.log(response.response_data)
                    //console.log(serviceKeyTableData)
                } else {
                    setloader(false)
                    Message.error("Something went wrong")

                }
            }
        } catch (error) {
            setloader(false)
        }
    }

    const getServiceListDetails = async () => {
        try {

            let response = await ManageApis("get", global.getServiceList);
            //console.log(response);

            if (response.message === "Success") {
                setServiceNameList(response?.response_data.map(row => ({
                    name: row.name,
                    id: row.id,
                })))
                setCurrentServiceId(response?.response_data[0]?.id)
                //console.log(serviceNameList)
            } else {
                //console.log(response)
                Message.error(response?.message)
            }
        } catch (error) {

            //console.log(error);
        }
    };

    const handleRefresh = async (record) => {
        try {
            setloader(true)
            let response = await ManageApis('get', global.RefreshAadharmaskingDeploymentServerKey + `ServerManagerId=${record}`)
            if (response.message == 'Success') {
                setloader(false)
                //console.log(response)
                setvisible(initialVisibleValue)
                Message.success(`Refreshed Succcessfully`)
                getAddDataServerDeployment()

                // setTimeout(() => { window.location.href = '/DeploymentServer' }, 1000)

            }
            else {
                setloader(false)
                setvisible(initialVisibleValue)
                Message.error("Refresh Failed")

            }
        } catch (error) {
            setloader(false)
            //console.log(error)
            Message.error("Something Went Wrong")
        }
    }
    const handleDelete = async (record) => {
        setloader(true)
        if (dev == true) {
            let response = await axios.post('http://localhost:3001' + global.getDeleteDataServerDeployment + `id=${record}`)
            Message.success(response.data)
            getAddDataServerDeployment()
            setloader(false)
        }
        else {
            let response = await ManageApis('post', global.getDeleteDataServerDeployment + `id=${record}`)
            if (response.message == 'Success') {
                setloader(false)
                //console.log(response)
                Message.success(`Deleted Succcessfully`)
                getAddDataServerDeployment()

                // setTimeout(() => { window.location.href = '/DeploymentServer' }, 1000)

            }
            else {
                setloader(false)
                Message.error("Something Went Wrong")

            }
        }
    }
    const handleAdd = (type, record) => {
        if (type == 'edit') {
            setRowData(record)
            setForm(record)
            //console.log(record)
        }

        setvisible((pre) => ({ show: true, type }))
        if (type == 'create') {
            setRowData({})
            setForm({})
            //console.log('helo')
        }
    }
    // const changedServiceid = (event) => {
    //   setCurrentServiceId(event.target.value)
    // }


    const handleChange = (e) => {
        const { name, value } = e.target;
        //console.log('hello')
        if (name == 'serviceapiaddress' || name == 'path' || name == 'key') {
            setForm(prev => ({ ...prev, [name]: value }))
        }

    }

    const handleAddServer = async () => {
        setloader(true)
        const date = new Date()
        const formatDate = moment(date).format('YYYY-MM-DD')
        //console.log('date --->', formatDate)
        const param = `serviceid=${currentServiceId}&serveripaddress=${form.serviceapiaddress}&path=${form.path}&key=${form.key}&updateddate=${formatDate}`
        let response = await ManageApis("post", global.addDataServerDeployment + param)
        if (response.message === "Success") {
            setloader(false)
            //console.log(response)
            setvisible(initialVisibleValue)
            Message.success("Server Added Successfully")
            getAddDataServerDeployment()
            // setTimeout(() => { window.location.href = '/DeploymentServer' }, 1000)

        }
        else {
            setloader(false)
            //console.log(param)
            setvisible(initialVisibleValue)
            Message.error("Something Went Wrong")
        }
    }
    // onchange function for pagination
    function onChangeTable(pagination) {
        //console.log(pagination);
        const { current, pageSize } = pagination;
        setTableLoader(true);
        // setServiceKeyTableData(dataTableInitialLoader(columns));
        setServiceKeyTableData([]);

        setTimeout(() => {

            setServiceKeyTableData(
                data.slice((current - 1) * pageSize, current * pageSize)
            );

            setcurrentPage(current);
            setTableLoader(false);
        }, 2000);
    }
    let isEmpty = false



    const handleSelectChange = (e) => {
        //console.log(e.target.value)
        setCurrentServiceId(e.target.value)
    }

    const handleUpdateServer = async () => {
        setloader(true)
        const date = new Date()
        const formatDate = moment(date).format('YYYY-MM-DD')
        const param = `id=${rowData.id}&serveripaddress=${form.serviceapiaddress}&path=${form.path}&key=${form.key}&updateddate=${formatDate}`
        let response = await ManageApis("post", global.getUpdateDataServerDeployment + param)
        if (response.message === "Success") {
            //console.log(response)
            setloader(false)
            setvisible(initialVisibleValue)
            Message.success("Server Updated Successfully")
            getAddDataServerDeployment()

            // setTimeout(() => { window.location.href = '/DeploymentServer' }, 1000)

        }
        else {
            setloader(false)
            //console.log(param)
            setvisible(initialVisibleValue)
            Message.error("Something Went Wrong")
        }
    }

    return (
        <>
            {<AlertBox show={alertData.show} message={alertData.message} handlecancel={() => setAlertData(initialAlertValue)} />}
            {loader && <Loader />}
            <div className="px-3">
                <div className="mb-3">
                    <div className='align-items-center d-flex justify-content-between flex-wrap'>
                        <div className='col col-sm d-flex pt-2'>
                            <h3 className='fw_600 font_18 text_master2 ms-2 mb-0'>
                                Deployment Server
                            </h3>
                        </div>
                        <div className="col-auto col-sm-auto pt-2">
                            <button className="btn px_btn btn-master px-4 rounded fw_500 font_12 w-100" onClick={() => handleAdd('create')}>
                                Add
                            </button>
                        </div>
                    </div>
                </div>
                <div className="table_type02 table-responsive custom_scroll1 ">
                    <table className="table table-bordered pb-2 mb-0 bg-white rounded-2  d-none border font_13 valign_middle">
                        <thead className="bg_master2 text-white">
                            <tr>
                                <th className="fw_500">Service</th>
                                <th className="fw_500">Server</th>
                                <th className="fw_500">Path</th>
                                <th className="fw_500">Key</th>
                                <th className="fw_500">Updated date</th>
                                <th className="fw_500 w_150x">Refresh Server</th>
                                <th className="fw_500 w_150x">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Aadhar Masking</td>
                                <td>https://mask.pixl.ai</td>
                                <td>/manage</td>
                                <td>
                                    <i class="far fa-eye cursor-pointer px_hover_1 font_18 text_master"></i>
                                </td>
                                <td>2023-07-27</td>
                                <td>
                                    <button className="btn px_btn btn-master py-1 rounded fw_500 font_12 w-100">Refresh</button>
                                </td>
                                <td>
                                    <div className="d-flex gap-2">
                                        <button className="btn px_btn btn-master-line py-1 rounded fw_500 px-2 font_12 w-100">Edit</button>
                                        <button className="btn px_btn btn-master py-1 rounded fw_500 px-2 font_12 w-100 ">Delete</button>
                                    </div>
                                </td>
                            </tr>

                        </tbody>
                    </table>


                </div>
                <div className="overflow-auto accountServicesDashBoard scrollbar1">

                <DataTable
                    columnData={columns}
                    rowData={serviceKeyTableData}
                    current={currentPage}
                    loading={TableLoader}
                    total={data.length}
                    onChangeTable={onChangeTable}
                />
                </div>
            </div>

            {/* ADD MODAL */}
            <PopupModal visible={visible.show} title={visible.type == 'edit' ? "Edit" : "Add"} size="lg" handleClose={handleModalClose} >
                <div>
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="mb-3">
                                <label className="mb-0 pb_2x text_master2 fw_500 font_14">
                                    Service<span className="text-danger">*</span>
                                </label>
                                {/* {//console.log(rowData)} */}
                                    { isEmpty = Object.keys(rowData).length === 0 }

                                {isEmpty ?
                                    <select className="form-select rounded font_12" onChange={handleSelectChange} >
                                        {serviceNameList?.map((itm) => (
                                            <option key={itm.id} value={itm.id}>{itm.name}</option>
                                        ))}
                                    </select>
                                    :
                                    <select className="form-select rounded font_12" disabled={visible.type == "edit"} >
                                        <option value={rowData.servicename}>{rowData.servicename}</option>
                                    </select>
                                }
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="mb-3">
                                <label className="mb-0 pb_2x text_master2 fw_500 font_14">
                                    Enter Server<span className="text-danger">*</span>
                                </label>

                                <input
                                    type="text"
                                    className="form-control rounded font_12"
                                    onChange={handleChange}
                                    name="serviceapiaddress"
                                    value={form.serviceapiaddress}
                                />

                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="mb-3">
                                <label className="mb-0 pb_2x text_master2 fw_500 font_14">
                                    Enter Path<span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control rounded font_12"
                                    onChange={handleChange}
                                    name="path"
                                    value={form.path}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="mb-3">
                                <label className="mb-0 pb_2x text_master2 fw_500 font_14">
                                    Enter Key<span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control rounded font_12"
                                    onChange={handleChange}
                                    name="key"
                                    value={form.key}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end gap-2">
                        <button className="btn px_btn btn-master-line px-4 rounded fw_500 font_12" onClick={() => setvisible(initialVisibleValue)}>Cancel</button>
                        <button className="btn px_btn btn-master px-4 rounded fw_500 font_12" onClick={visible.type == 'edit' ? handleUpdateServer : handleAddServer}>Submit</button>
                    </div>
                </div>
            </PopupModal>

            {/* EDIT MODAL */}
            {/* <PopupModal title="Edit" size="lg">
        <div>
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="mb-3">
                <label className="mb-0 pb_2x text_master2 fw_500 font_14">
                Service<span className="text-danger">*</span>
                </label>
                <select className="form-control rounded font_12" disabled>
                  <option>test</option>
                  <option>test</option>
                </select>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="mb-3">
                <label className="mb-0 pb_2x text_master2 fw_500 font_14">
                Enter Server<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control rounded font_12"
                />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="mb-3">
                <label className="mb-0 pb_2x text_master2 fw_500 font_14">
                Enter Path<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control rounded font_12"
                />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="mb-3">
                <label className="mb-0 pb_2x text_master2 fw_500 font_14">
                Enter Key<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control rounded font_12"
                />
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="mb-3">
                <label className="mb-0 pb_2x text_master2 fw_500 font_14">
                Created Date<span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control rounded font_12"
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end gap-2">
            <button className="btn px_btn btn-master-line px-4 rounded fw_500 font_12">Cancel</button>
            <button className="btn px_btn btn-master px-4 rounded fw_500 font_12">Submit</button>
          </div>
        </div>
      </PopupModal> */}

        </>
    );
}

export default DeploymentServer;
